import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ed } from '../../lib/editTexts';
import { slotUrl, useWebsiteImages } from '../../lib/publicContent';
import '../../styles/mobile.css';

// Gleiche Kennungen wie das Desktop-Menue (PublicNav) und die Desktop-Fusszeile (PublicFooter).
const NAV = [
  { to: '/', key: 'nav.home' },
  { to: '/about', key: 'nav.about' },
  { to: '/opfer', key: 'nav.giving' },
  { to: '/gebet', key: 'nav.prayer' },
];

/**
 * Gemeinsame Hülle aller mobilen Seiten: sticky App-Bar, Slide-in-Menü, Footer.
 */
export default function MobileLayout({ children }) {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const slots = useWebsiteImages();

  // Menü bei Seitenwechsel schließen
  useEffect(() => { setMenuOpen(false); }, [pathname]);

  // Hintergrund nicht scrollen lassen, solange das Menü offen ist
  useEffect(() => {
    if (!menuOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [menuOpen]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="kac-m">
      <header className={`m-bar${scrolled ? ' scrolled' : ''}`}>
        <Link to="/" className="m-bar-logo">
          <img src={slotUrl(slots, 'brand.logo', 0, '/kac-assets/KAC-Badge.png')} alt={t('nav.brand')} data-slot="brand.logo" />
          <span {...ed('nav.brand')}>{t('nav.brand')}</span>
        </Link>
        <button
          type="button"
          className={`m-burger${menuOpen ? ' open' : ''}`}
          aria-label={menuOpen ? t('nav.menu_close') : t('nav.menu_open')}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(o => !o)}
        >
          <span /><span /><span />
        </button>
      </header>

      {menuOpen && (
        <>
          <div className="m-menu-backdrop" onClick={() => setMenuOpen(false)} />
          <nav className="m-menu" aria-label={t('nav.main_menu')}>
            <div className="m-menu-head">
              <span {...ed('nav.menu')} style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--m-muted)' }}>
                {t('nav.menu')}
              </span>
              <button
                type="button"
                className="m-burger open"
                aria-label={t('nav.menu_close')}
                onClick={() => setMenuOpen(false)}
              >
                <span /><span /><span />
              </button>
            </div>

            <div className="m-menu-nav">
              {NAV.map(({ to, key }) => (
                <Link key={to} to={to} className={pathname === to ? 'active' : ''} {...ed(key)}>
                  {t(key)}
                </Link>
              ))}
            </div>

            <div className="m-menu-foot">
              <div className="m-lang" style={{ marginBottom: 18 }}>
                <button
                  type="button"
                  className={i18n.language?.startsWith('de') ? 'on' : ''}
                  onClick={() => i18n.changeLanguage('de')}
                >DE</button>
                <span style={{ color: 'rgba(120,100,70,0.35)' }}>/</span>
                <button
                  type="button"
                  className={i18n.language?.startsWith('en') ? 'on' : ''}
                  onClick={() => i18n.changeLanguage('en')}
                >EN</button>
              </div>



              <div className="m-foot-links" style={{ marginTop: 22 }}>
                <Link to="/support" {...ed('footer.support')}>{t('footer.support')}</Link>
                <Link to="/privacy" {...ed('footer.privacy')}>{t('footer.privacy')}</Link>
              </div>
            </div>
          </nav>
        </>
      )}

      {children}

      <footer className="m-foot">
        <div {...ed('footer.copyright')}>{t('footer.copyright')}</div>
        <div className="m-foot-links">
          <Link to="/support" {...ed('footer.support')}>{t('footer.support')}</Link>
          <Link to="/privacy" {...ed('footer.privacy')}>{t('footer.privacy')}</Link>
        </div>
      </footer>
    </div>
  );
}
